export const formatPrice = (stringifedPrice: string | undefined, digit = 2) => {
  const price = Number(stringifedPrice || 0);
  return price && !isNaN(price)
    ? (Math.round(price * Math.pow(10, digit)) / Math.pow(10, digit))?.toFixed(
        digit,
      )
    : undefined;
};
